export const CATALOG_LIST_SORT_VALUES = [
  "operational",
  "updated_desc",
  "created_desc",
  "published_desc",
  "title_asc",
];

export const CATALOG_LIST_STATUS_VALUES = [
  "draft",
  "active",
  "unpublished",
  "archived",
];

export const CATALOG_LIST_STOCK_VALUES = ["OK", "LOW_STOCK", "OUT_OF_STOCK"];

export const CATALOG_LIST_PRODUCT_FAMILIES = ["shoes", "textile", "accessories"];

export const DEFAULT_CATALOG_LIST_FILTERS = {
  search: "",
  status: "",
  brandId: "",
  merchandisingTypeId: "",
  productFamily: "",
  stockRiskLevel: "",
  sortBy: "operational",
};

const isPositiveId = (value) => /^\d+$/.test(String(value || "").trim());

export const readCatalogListParams = (searchParams) => {
  const sortBy = String(searchParams.get("sortBy") || "").trim();
  const status = String(searchParams.get("status") || "").trim();
  const page = Number(searchParams.get("page"));
  const productFamily = String(searchParams.get("productFamily") || "").trim();
  const stockRiskLevel = String(searchParams.get("stockRiskLevel") || "").trim();
  const brandId = String(searchParams.get("brandId") || "").trim();
  const merchandisingTypeId = String(
    searchParams.get("merchandisingTypeId") || ""
  ).trim();

  return {
    filters: {
      search: String(searchParams.get("search") || ""),
      status: CATALOG_LIST_STATUS_VALUES.includes(status) ? status : "",
      brandId: isPositiveId(brandId) ? brandId : "",
      merchandisingTypeId: isPositiveId(merchandisingTypeId)
        ? merchandisingTypeId
        : "",
      productFamily: CATALOG_LIST_PRODUCT_FAMILIES.includes(productFamily)
        ? productFamily
        : "",
      stockRiskLevel: CATALOG_LIST_STOCK_VALUES.includes(stockRiskLevel)
        ? stockRiskLevel
        : "",
      sortBy: CATALOG_LIST_SORT_VALUES.includes(sortBy)
        ? sortBy
        : DEFAULT_CATALOG_LIST_FILTERS.sortBy,
    },
    page: Number.isInteger(page) && page > 0 ? page : 1,
  };
};

export const buildCatalogListSearchParams = (filters, page) => {
  const nextParams = new URLSearchParams();

  if (filters.search.trim()) nextParams.set("search", filters.search.trim());
  if (filters.status) nextParams.set("status", filters.status);
  if (filters.brandId) nextParams.set("brandId", filters.brandId);
  if (filters.merchandisingTypeId) {
    nextParams.set("merchandisingTypeId", filters.merchandisingTypeId);
  }
  if (filters.productFamily) nextParams.set("productFamily", filters.productFamily);
  if (filters.stockRiskLevel) nextParams.set("stockRiskLevel", filters.stockRiskLevel);
  if (filters.sortBy) nextParams.set("sortBy", filters.sortBy);
  if (page > 1) nextParams.set("page", String(page));

  return nextParams;
};
